import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { Link } from "@tanstack/react-router";

import { analytics } from "@/config/analytics";
import { Button, Card, Heading } from "@/ui";

export const UpsellCareplanCard = () => {
  return (
    <Card className="flex flex-col">
      <div className="flex flex-col gap-6 px-6 py-7 md:gap-8 md:px-14 md:py-12">
        <Heading level={2}>Get a Free Care Plan</Heading>
        <p>
          Made to manage your symptoms, each plan provides product, dose and use guidance based on
          your inputs and ongoing feedback. And you can message our clinician-led team anytime.
        </p>
        <img
          alt="Get a free care plan"
          className="rounded-lg"
          src="/assets/images/get-a-free-care-plan.png"
        />
        <Button asChild>
          <Link
            className="flex w-full items-center justify-center"
            onClick={() => {
              return analytics.track("post_purchase_upsell_careplan_viewed");
            }}
            to="/profiling"
          >
            <span>Create Your Free Care Plan Now</span>
            <ArrowRightIcon className="h-5" />
          </Link>
        </Button>
      </div>
    </Card>
  );
};
